export const windowRedirect = (path)=>{
    window.location.href=path;
}